import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [searchText, setSearchText] = useState('');
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setSearchOpen(false);
  }, [location.pathname]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500">
              <i className="ri-movie-2-fill text-foreground-50 text-lg"></i>
            </div>
            <span className="font-heading text-xl font-bold text-foreground-950">
              木瓜影院
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/')
                  ? 'bg-primary-500/15 text-primary-500'
                  : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-200/50'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                  location.pathname.includes(`/category/${cat.id}`)
                    ? 'bg-primary-500/15 text-primary-500'
                    : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-200/50'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                isActive('/about')
                  ? 'bg-primary-500/15 text-primary-500'
                  : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-200/50'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="flex items-center gap-2">
            <div className="relative">
              {searchOpen && (
                <div className="absolute right-0 top-full mt-2 bg-background-50 border border-background-200/70 rounded-lg p-2 w-64">
                  <div className="flex items-center gap-2 bg-background-100 rounded-md px-3 py-2">
                    <i className="ri-search-line text-foreground-400 text-sm"></i>
                    <input
                      type="text"
                      value={searchText}
                      onChange={(e) => setSearchText(e.target.value)}
                      placeholder="搜索影片..."
                      className="bg-transparent border-none outline-none text-sm text-foreground-950 placeholder-foreground-400 w-full"
                      autoFocus
                    />
                  </div>
                </div>
              )}
              <button
                onClick={() => setSearchOpen(!searchOpen)}
                className="w-9 h-9 flex items-center justify-center rounded-lg text-foreground-600 hover:text-foreground-950 hover:bg-background-200/50 transition-colors cursor-pointer"
                aria-label="搜索"
              >
                <i className="ri-search-line text-lg"></i>
              </button>
            </div>
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="md:hidden w-9 h-9 flex items-center justify-center rounded-lg text-foreground-600 hover:text-foreground-950 hover:bg-background-200/50 transition-colors cursor-pointer"
              aria-label="菜单"
            >
              <i className={`text-lg ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link
              to="/"
              className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                isActive('/')
                  ? 'bg-primary-500/15 text-primary-500'
                  : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-200/50'
              }`}
            >
              首页
            </Link>
            {categories.map((cat) => (
              <Link
                key={cat.id}
                to={`/category/${cat.id}`}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname.includes(`/category/${cat.id}`)
                    ? 'bg-primary-500/15 text-primary-500'
                    : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-200/50'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                isActive('/about')
                  ? 'bg-primary-500/15 text-primary-500'
                  : 'text-foreground-600 hover:text-foreground-950 hover:bg-background-200/50'
              }`}
            >
              关于我们
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
}